import { Col, Button } from "reactstrap";

function Verse(props) {

  const handleClick = () => {
    props.onVerseClick(props.verse);
  };

  return (
    <Col lg="3" className="text-center">
      <Button className="gallery-img-button" onClick={handleClick}>
        <img src={props.verse.VerseImage} alt={props.verse.Description} />
      </Button>
      <Button onClick={handleClick} size="sm" color="primary">
        Select
      </Button>
    </Col>
  );
}

export default Verse;
